export const GET_FILE_TYPES = "GET_FILE_TYPES"
export const GET_FILE_TYPES_FAIL = "GET_FILE_TYPES_FAIL"
export const GET_FILE_TYPES_SUCCESS = "GET_FILE_TYPES_SUCCESS"

export const ADD_NEW_FILE_TYPE = "ADD_NEW_FILE_TYPE"
export const ADD_FILE_TYPE_SUCCESS = "ADD_FILE_TYPE_SUCCESS"
export const ADD_FILE_TYPE_FAIL = "ADD_FILE_TYPE_FAIL"

export const UPDATE_FILE_TYPE = "UPDATE_FILE_TYPE"
export const UPDATE_FILE_TYPE_SUCCESS = "UPDATE_FILE_TYPE_SUCCESS"
export const UPDATE_FILE_TYPE_FAIL = "UPDATE_FILE_TYPE_FAIL"

export const DELETE_FILE_TYPE = "DELETE_FILE_TYPE"
export const DELETE_FILE_TYPE_SUCCESS = "DELETE_FILE_TYPE_SUCCESS"
export const DELETE_FILE_TYPE_FAIL = "DELETE_FILE_TYPE_FAIL"





